<h1 mat-dialog-title>Success!</h1>
<mat-dialog-content>
    {{data.institutionName | titlecase }} was successfully linked. The more banks you link, the better and faster we can assess the
    health of your business.
</mat-dialog-content>
<div mat-dialog-actions class="flex row end-center">
  <button mat-button [mat-dialog-close]="false">Link another bank</button>
  <button mat-button [mat-dialog-close]="true" color="primary">Ok</button>
</div>